import React from "react";
import { Tab, Tabs, Spinner } from "react-bootstrap";
import useCalendarDashboardComponent from "./useCalendarDashboardComponent";
import { ScheduledEventsCard } from "../ScheduledEventsCard";
import EmptyFeedCard from "../EmptyFeedCard";

export default function CalendarDashboardComponent(props) {
  const {
    calendarInterviewsLoading,
    calendarPastInterviews,
    calendarUpcomingInterviews,
    onViewCalendarClick,
    onJoinHMSClick,
  } = useCalendarDashboardComponent(props);

  return (
    <div className="dashboard-calender-wrapper h-100">
      <div className="dashboard-component-container border border-radius-10 bg-white p-3 mt-3 h-100">
        <div className="d-flex align-items-center justify-content-between">
          <h4>Calendar Events</h4>
          <button
            onClick={onViewCalendarClick}
            className="bg-transparent border-0 fs-14 text-primary font-weight-medium"
          >
            View All
          </button>
        </div>
        <Tabs defaultActiveKey="Upcoming" className="mt-3">
          <Tab eventKey="Upcoming" title="Upcoming">
            <p className="fs-smallest text-grey-4 mt-3 font-weight-medium mb-1">
              Latest
            </p>
            {calendarInterviewsLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <div className="dashboard-calender-list">
                {calendarUpcomingInterviews?.results &&
                  Array.isArray(calendarUpcomingInterviews.results) &&
                  calendarUpcomingInterviews.results.map((item) => (
                    <ScheduledEventsCard
                      eventDetails={item}
                      onJoinHmsClick={onJoinHMSClick}
                      isPastEvent={true}
                    />
                  ))}
                {calendarUpcomingInterviews?.count === 0 ? (
                  <EmptyFeedCard
                    src="/assets/images/calendar-empty-state.svg"
                    message={"No Scheduled Events"}
                    description={
                      "This space will display upcoming events once scheduled."
                    }
                    btnText={"Schedule an Event"}
                    link={"/calender-dashboard"}
                  />
                ) : null}
              </div>
            )}
          </Tab>

          <Tab eventKey="Completed" title="Completed">
            {calendarInterviewsLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <div className="dashboard-calender-list">
                {calendarPastInterviews?.results &&
                  Array.isArray(calendarPastInterviews?.results) &&
                  calendarPastInterviews.results.map((item) => (
                    <ScheduledEventsCard
                      eventDetails={item}
                      isPastEvent={false}
                    />
                  ))}
                {calendarPastInterviews?.count === 0 ? (
                  <EmptyFeedCard
                    src="/assets/images/calendar-empty-state.svg"
                    message={"No Scheduled Events"}
                    description={
                      "This space will display upcoming events once scheduled."
                    }
                    btnText={"Schedule an Event"}
                    link={"calender-dashboard"}
                  />
                ) : null}
              </div>
            )}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
